<template>
    <section>
        <o-field label="Small">
            <o-select placeholder="Select a character" size="small">
                <option value="flint">Flint</option>
                <option value="silver">Silver</option>
            </o-select>
        </o-field>

        <o-field label="Default">
            <o-select placeholder="Select a character">
                <option value="flint">Flint</option>
                <option value="silver">Silver</option>
            </o-select>
        </o-field>

        <o-field label="Medium">
            <o-select placeholder="Select a character" size="medium">
                <option value="flint">Flint</option>
                <option value="silver">Silver</option>
            </o-select>
        </o-field>

        <o-field label="Large">
            <o-select placeholder="Select a character" size="large">
                <option value="flint">Flint</option>
                <option value="silver">Silver</option>
            </o-select>
        </o-field>
    </section>
</template>
